import dayjs from 'dayjs';

import { IDefaultPaymentMethod } from '@mopla/data-models';

/**
 * Validates if a payment method is still valid (non-expired card, valid alternative methods).
 * Based on validation logic from useDefaultPaymentMethod lines 132-151.
 */
export const isPaymentMethodValid = (
	paymentMethod: IDefaultPaymentMethod | null
): boolean => {
	if (!paymentMethod) {
		return false;
	}

	const { card, paypal, sepa_debit, type } = paymentMethod;

	/** Card validation - check expiry */
	const isCardValid =
		card &&
		dayjs().isBefore(
			dayjs({
				month: card.exp_month - 1,
				year: card.exp_year,
			}).endOf('month')
		);

	/** Check if any valid payment method exists */
	return Boolean(
		isCardValid ||
			paypal ||
			sepa_debit ||
			type === 'klarna' ||
			type === 'revolut_pay' ||
			type === 'amazon_pay' ||
			type === 'pay_by_bank'
	);
};
